/* BF Overflow Universal Fix — mobile-first, idempotent
 - Runs on load + resize + dynamic section loads
 - Marks touched elements to avoid re-application
 - Only runs on mobile screens (adjustable threshold)
 */
(() => {
  'use strict';
  const MOBILE_QUERY = '(max-width: 768px)';
  const FIX_ATTR = 'data-bf-fixed';
  const isMobile = () => window.matchMedia && matchMedia(MOBILE_QUERY).matches;
  const clampText = (el, cs) => {
    if (cs.whiteSpace && cs.whiteSpace !== 'normal') {
      el.style.whiteSpace = 'normal';
      el.style.overflowWrap = 'anywhere';
      el.style.wordBreak = 'break-word';
    }
  };
  const clampBox = (el) => {
    el.style.maxWidth = '100%';
    el.style.minWidth = '0';
    el.style.boxSizing = 'border-box';
    el.style.overflowX = 'hidden';
  };
  const clampPositioned = (el, cs) => {
    if (/(absolute|fixed|sticky)/.test(cs.position)) {
      el.style.left = '0';
      el.style.right = '0';
    }
  };
  const clampTransform = (el, cs) => {
    if (cs.transform && cs.transform !== 'none' && /matrix|translateX|translate\(/.test(cs.transform)) {
      el.style.transform = 'none';
      el.style.translate = '0';
    }
  };
  const clampMedia = (el) => {
    if (el.tagName === 'IMG' || el.tagName === 'VIDEO' || el.tagName === 'CANVAS') {
      el.style.maxWidth = '100%';
      el.style.height = 'auto';
    }
  };
  const applyFix = (el) => {
    if (el.closest('scrolling-items-container')) return false;
    if (!el || el.hasAttribute(FIX_ATTR)) return false;
    const cs = getComputedStyle(el);
    clampText(el, cs);
    clampBox(el);
    clampPositioned(el, cs);
    clampMedia(el);
    el.setAttribute(FIX_ATTR, '1');
    return true;
  };
  const scanAndFix = () => {
    if (!isMobile()) return;
    const W = window.innerWidth;
    let fixed = 0;
    const els = document.body ? document.body.getElementsByTagName('*') : [];
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      const r = el.getBoundingClientRect();
      if (r.width - W > 1) {
        if (applyFix(el)) fixed++;
      }
    }
    document.documentElement.style.overflowX = 'clip';
    document.body.style.overflowX = 'clip';
  };
  const debounce = (fn, ms) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), ms);
    };
  };
  const runIdle = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(scanAndFix, { timeout: 2000 });
    } else {
      setTimeout(scanAndFix, 0);
    }
  };
  const init = () => {
    runIdle();
    window.addEventListener('load', runIdle, { once: true });
    window.addEventListener('resize', debounce(runIdle, 250), { passive: true });
    window.addEventListener('orientationchange', debounce(runIdle, 250), { passive: true });
    document.addEventListener('shopify:section:load', runIdle);
    document.addEventListener('shopify:section:reorder', runIdle);
    document.addEventListener('shopify:section:unload', runIdle);
    document.addEventListener('page:load', runIdle);
    document.addEventListener('page:change', runIdle);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
